import type { Department } from '../api/taskQueries.ts';

/** An overdue tab's id, safe as an id: "Social Work" holds a space, which aria-labelledby would read as two ids (A-#149). */
export const overdueTabId = (d: Department) => `overdue-tab-${d.replace(/\s/g, '-')}`;
